export default {
  contact: {
    intro: 'Please complete the form below to submit your inquiry.',
    inquiryType: {
      label: 'Inquiry Type',
      placeholder: 'Please select the topic of your inquiry.',
      quote: 'Request for Quote',
      recruitment: 'Recruitment',
      other: 'Other',
    },
    companyName: {
      label: 'Company name / School name',
      placeholder: 'Sample corporation',
    },
    yourName: {
      label: 'Your name',
      firstName: 'First name',
      lastName: 'Last name',
    },
    phone: {
      label: 'Phone number',
      placeholder: '+1 8005550100 (enter numbers only, no dashes or spaces)',
    },
    email: {
      label: 'Email address',
      placeholder: 'your@email.com',
    },
    productInterest: {
      label: 'Product Name',
      placeholder: 'e.g. Sodium Hydroxide, Zinc Oxide',
    },
    application: {
      label: 'Products for Quotation (multiple allowed)',
      hint: 'e.g. Sodium Hydroxide, Zinc Oxide',
    },
    destinationPort: {
      label: 'Destination Port',
      placeholder: 'e.g. Shanghai, Rotterdam',
    },
    quantityPerShipment: {
      label: 'Quantity per Shipment',
      placeholder: 'e.g. 1 M/T, 2 FCL',
    },
    inquiryDetails: {
      label: 'Details of your inquiry',
      placeholder: 'Please provide as much detail as possible about your question or request.',
    },
    hearAbout: {
      label: 'How did you hear about us?',
      hint: '(You can select more than one option)',
      options: ['Website', 'Social media', 'Referral', 'Search engine', 'Job board', 'Event', 'Media', 'Other'],
    },
    privacy: {
      text: ' — I have read and agree.',
      link: 'Privacy Policy',
    },
    success: "Thank you for your inquiry. We will review the details and get back to you shortly.",
    error: 'Something went wrong. Please try again.',
    submit: 'Confirm',
    submitting: 'Sending...',
  },
};
